export default function renderFluent({ partnerId }) {
  return `
    <link referrerpolicy="no-referrer-when-downgrade" rel="stylesheet" href="https://api.tnapplications.com/assets/${partnerId}/flow-container.css" />
    <script referrerpolicy="no-referrer-when-downgrade" src="https://api.tnapplications.com/assets/${partnerId}/flow-container.js"></script>

    <script>
      const fc = new FlowContainer({
        params: {
          email: '{email}',
          firstname: '{firstName}',
          lastname: '{lastName}',
          gender: '{gender}',
          address1: '{address1}',
          address2: '{address2}',
          city: '{city}',
          state: '{state}',
          zip: '{zip}',
          telephone: '{phone}',
          subaff1: '{pid}',
          subaff3:'{sid1}',
          subaff4:'{pe_key}',
          transactionId: '{pe_key}'
        }
      });
      fc.show();

      window.addEventListener('flowContainerClosed', function() {
        window.location.href = '{nextURL}';
      });
    </script>

    <div id="af-placement"></div>
  `.trim()
}
